import type {
  LegStateBookingPanel,
  LegBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/flights/legsBookingPanel';

export const get = (state: LegStateBookingPanel, id: string): LegBookingPanel => state.byId[id];
export const all = (state: LegStateBookingPanel): Record<string, LegBookingPanel> => state.byId;
